import type {ScanResult} from "../types";
import type {FC} from "react";

interface ScanResultModalProps {
    result: ScanResult | null;
    onClose: () => void;
}
const ScanResultModal: FC<ScanResultModalProps> = ({ result, onClose }) => {
    if (!result) return null;

    const isValid = result.status === 'valid';
    const content = isValid ? (
        <div className="w-full max-w-sm sm:max-w-md bg-green-500/10 border-2 border-green-500 rounded-2xl text-center p-6 sm:p-12 flex flex-col items-center shadow-2xl shadow-green-500/20">
            <svg className="w-24 h-24 sm:w-32 sm:h-32 text-green-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
            <p className="text-4xl sm:text-5xl font-bold mt-6 text-white">VALIDO</p>
            <p className="text-lg sm:text-xl text-green-300 mt-2">Buon Appetito!</p>
        </div>
    ) : (
        <div className="w-full max-w-sm sm:max-w-md bg-red-500/10 border-2 border-red-500 rounded-2xl text-center p-6 sm:p-12 flex flex-col items-center shadow-2xl shadow-red-500/20">
            <svg className="w-24 h-24 sm:w-32 sm:h-32 text-red-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
            <p className="text-4xl sm:text-5xl font-bold mt-6 text-white">NON VALIDO</p>
            <p className="text-xl text-red-300 mt-2">Non Autorizzato</p>
        </div>
    );

    return (
        <div className="fixed inset-0 z-[100] bg-black/70 flex items-center justify-center p-4" onClick={onClose}>
            {content}
        </div>
    );
};

export default ScanResultModal;